/** @jsx  jsx */
import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../../styles/colors';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';

export const promoCard = css({
  color: colorsPalette.black,
  backgroundColor: colorsPalette.brown10,
  textDecoration: 'none',
  borderBottomLeftRadius: 45,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  padding: '16px 16px 24px',
  maxWidth: 460,
  minHeight: 472,
  height: '100%',
  [MediaQueries.mdAndUp]: {
    maxWidth: 'none',
    minHeight: 520,
  },
  '&:visited': {
    color: colorsPalette.black,
    textDecoration: 'none',
  },
  '&:focus': {
    border: `1px solid ${colorsPalette.teal}`,
    outline: 0,
  },
  [MediaQueries.lgAndUp]: {
    padding: '32px 32px 48px 32px',
  },
});

export const promoCardBorder = css({
  border: `1px solid ${colorsPalette.brown10}`,
});

export const clickablePromoCard = css({
  cursor: 'pointer',
  '&:hover': {
    borderColor: colorsPalette.transparent,
    boxShadow: shadows.shadow80,
    outline: 0,
    border: `1px solid ${colorsPalette.brown10}`,
  },
});

export const topLine = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'top',
  marginBottom: 18,
});

export const headlineWrapper = css({
  paddingRight: 20,
});

export const headline = css(typography.effra28, {
  display: 'inline',
  backgroundSize: '2px 1em',
});

export const arrow = css({
  color: colorsPalette.red,
});

export const body = css(typography.effra16, {
  marginBottom: 40,
});

export const goodFor = css(typography.effra16, {
  marginBottom: 8,
  fontWeight: fontWeights.medium,
});

export const goodForItem = css(typography.effra16, {
  margin: '12px 0',
  display: 'flex',
});

export const itemCheck = css({
  color: colorsPalette.red,
  marginRight: 13,
  paddingTop: 3,
  fontSize: 12,
});

export const ctaBlock = css({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  color: colorsPalette.red,
});

export const ctaText = css({
  lineHeight: 1.67,
  borderBottom: `1px solid ${colorsPalette.red20}`,
});
